import { z } from 'zod/v4';

/**
 * Схема для bulk-операций по списку id.
 * ids: массив от 1 до 100 целых положительных чисел.
 */
export const bulkIdsSchema = z.object({
  ids: z
    .array(z.number().int('ID должен быть целым числом').positive('ID должен быть положительным'))
    .min(1, 'Список ID не может быть пустым')
    .max(100, 'Нельзя обработать более 100 записей за раз'),
});

export type BulkIdsInput = z.infer<typeof bulkIdsSchema>;
